import { render, staticRenderFns } from "./Menu.vue?vue&type=template&id=65ebe5bc&scoped=true&"
import script from "./Menu.vue?vue&type=script&lang=js&"
export * from "./Menu.vue?vue&type=script&lang=js&"
import style0 from "./Menu.vue?vue&type=style&index=0&id=65ebe5bc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ebe5bc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\workspace\\001.src\\003.aikl_wrokspace\\aikl_v2_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('65ebe5bc')) {
      api.createRecord('65ebe5bc', component.options)
    } else {
      api.reload('65ebe5bc', component.options)
    }
    module.hot.accept("./Menu.vue?vue&type=template&id=65ebe5bc&scoped=true&", function () {
      api.rerender('65ebe5bc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mng/Menu.vue"
export default component.exports